import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { logout } from '../../store/actions/auth';
import { Redirect } from 'react-router-dom';
import { func } from 'prop-types';

const Logout = ({ logout }) => {
  useEffect(() => {
    logout()
  }, []) //eslint-disable-line

  return <Redirect to={'/'} />
}

Logout.propTypes = {
  logout: func,
}

Logout.defaultProps = {
  logout: () => { },
}

export default connect(null, { logout })(Logout)